<template>
	<div class="Release">
		<el-form
				:model="selectForm"
				ref="selectForm"
				:label-position="labelPosition"
				label-width="120"
				inline
				class="custom-formScreen"
		>
			<el-form-item
					label="选择分公司"
					prop="branchCompany"
					v-if="
							[1].includes(str.type) &&
								str.superDepartmentName !== '客服部' &&
								str.superDepartmentName !== '常规客服部'
						"
			>
				<el-select
						v-model="value6"
						placeholder="请选择"
						@change="shopChange6"
						value-key="company_id"
						filterable
				>
					<el-option
							v-for="item in arr6"
							:key="item.company_id"
							:label="item.companyName"
							:value="item"
					></el-option>
				</el-select>
			</el-form-item>
			<el-form-item
					label="选择子公司"
					prop="sonCompany"
					v-if="[2, 1].includes(str.type)"
			>
				<el-select
						v-model="value7"
						placeholder="请选择"
						value-key="rid"
						@change="shopChange7"
						filterable
				>
					<el-option
							v-for="item in arr7"
							:key="item.company_id"
							:label="item.companyName"
							:value="item"
					></el-option>
				</el-select>
			</el-form-item>
			<el-form-item label="选择分部门" v-if="!disabledInput2">
				<el-select
						v-model="value2"
						filterable
						placeholder="请选择"
						@change="shopChange2"
				>
					<el-option
							v-for="item2 in this.arr1"
							:key="item2.value"
							:label="item2.departmentName"
							:value="item2"
					></el-option>
				</el-select>
			</el-form-item>

			<el-form-item label="选择组" v-if="!disabledInput3">
				<el-select
						v-model="value3"
						filterable
						placeholder="请选择"
						@change="shopChange3"
				>
					<el-option
							v-for="item3 in this.arr2"
							:key="item3.value"
							:label="item3.groupName"
							:value="item3"
					></el-option>
				</el-select>
			</el-form-item>

			<el-form-item label="选择员工" v-if="!disabledInput4">
				<el-select
						v-model="value4"
						filterable
						placeholder="请选择"
						@change="shopChange4"
				>
					<el-option
							v-for="item4 in this.arr3"
							:key="item4.value"
							:label="item4.roleUserName"
							:value="item4"
					></el-option>
				</el-select>
			</el-form-item>
			<el-form-item label="选择店铺" prop="shopvalue">
				<el-select
						v-model="value5"
						filterable
						placeholder="请选择"
						clearable
						@change="shopChange5"
				>
					<el-option
							v-for="item5 in this.arr4"
							:key="item5.value"
							:label="item5.shopName"
							:value="item5"
							:style="{ color: item5.state === 0 ? 'red' : '' }"
					></el-option>
				</el-select>
			</el-form-item>
			<!--					<el-form-item label="采购需求状态" prop="purchaseDemandValue">-->
			<!--						<el-select-->
			<!--								v-model="selectForm.demandValue"-->
			<!--								placeholder="请选择"-->
			<!--								@change="changeDemand"-->
			<!--								@clear="changeDemand"-->
			<!--								clearable-->
			<!--						>-->
			<!--							<el-option-->
			<!--									v-for="(item, index) in demandValue"-->
			<!--									:key="index"-->
			<!--									:label="item.label"-->
			<!--									:value="item.label"-->
			<!--							></el-option>-->
			<!--						</el-select>-->
			<!--					</el-form-item>-->
			<el-form-item label="开始日期" prop="startTime">
				<el-date-picker
						v-model="selectForm.startTime"
						align="right"
						type="datetime"
						placeholder="选择日期"
						format="yyyy-MM-dd HH:mm:ss"
						@change="startTime"
						:picker-options="pickerOptions"
				></el-date-picker>
				<!-- @change="startTime" -->
			</el-form-item>
			<el-form-item label="结束日期" prop="endTime">
				<el-date-picker
						v-model="selectForm.endTime"
						align="right"
						type="datetime"
						placeholder="选择日期"
						format="yyyy-MM-dd HH:mm:ss"
						@change="endTime"
						:picker-options="pickerOptions"
				></el-date-picker>

			</el-form-item>

			<el-input clearable placeholder="请输入查询内容" v-model="selectForm.searchStr" style="width: 360px;margin-top: 3px" @input="selectForm.searchStr = selectForm.searchStr.replace(/\s+/g, '')"
			>
				<el-select v-model="selectForm.searchType" slot="prepend" style="width: 100px" clearable
				>
					<el-option label="ParentSKU" value="1"></el-option>
					<el-option label="SKU" value="2"></el-option>
					<el-option label="产品编号" value="3"></el-option>
					<el-option label="标题" value="4"></el-option>
					<el-option label="备注" value="5"></el-option>
				</el-select>
			</el-input>




			<el-button
					type="primary"
					style="margin-left: 10px;"
					@click="Search2"
			>搜索</el-button
			>
			<el-button type="primary" @click="searchReset"
			>重置</el-button>
		</el-form>
		<div class="summary_bag">
			<div class="summary_complete_bag">
				<div class="status_button">
					<el-radio-group v-model="selectForm.onlineStatus" style="margin-bottom: 30px;" @change="changeStatus">
						<el-radio-button label="88">全部</el-radio-button>
						<el-radio-button label="1">在售</el-radio-button>
						<el-radio-button label="2">缺货</el-radio-button>
						<el-radio-button label="3">审核中</el-radio-button>
						<el-radio-button label="4">失败</el-radio-button>
						<el-radio-button label="5">已下架</el-radio-button>
						<el-radio-button label="6">归档</el-radio-button>
					</el-radio-group>
				</div>
			</div>
			<!-- 符合查询条件的产品共-->
			<div class="summary_pagenum">
				<div class="summary_query">
					符合查询条件的产品共
					<span>{{ count }}</span>
					件
				</div>
			</div>
			<div class="summary_content">
				<div class="summary_batch">
					<span>已选择产品{{ piece }}件</span>
					<template>
						<span @click="piliangTongbu" style="cursor:pointer">同步</span>
						<span @click="piliangEdit" style="cursor:pointer">批量编辑</span>
						<span @click="guidangItem(false)" style="cursor:pointer">批量归档</span>
						<span @click="qxGuidangItem(false)" style="cursor:pointer">取消归档</span>

					</template>
				</div>
				<div class="summary_list">
					<!-- 头部 -->
					<el-table
							:data="tableList"
							style="width: 100%"
							v-loading="load_data"
							element-loading-text="拼命加载中"
							border
							@selection-change="on_batch_select"
							:header-cell-style="iscenter"
							stripe
							class="pg-table"
							:cell-class-name="'pg-cell'"
							:header-cell-class-name="'pg-header-cell'"
							fit

					>
						<!-- :cell-style="style" -->
						<el-table-column
								width="50"
								type="selection"
								align="center"
						></el-table-column>
						<el-table-column
								label="图片"
								width="90"
								align="left"
						>
							<template slot-scope="scope">
								<el-popover trigger="hover" placement="right" :open-delay="600">
									<img
											:src="scope.row.primaryImage"
											class="prduct_img"
											alt
									/>
									<div class="scope_img" slot="reference">
										<img
												:src="scope.row.primaryImage"
												alt
										/>
									</div>
								</el-popover>
							</template>
						</el-table-column>
						<el-table-column
								label="标题/OzonSku/店铺/分类"
								prop="productNumber"
								align="left"
								min-width="240"
								show-overflow-tooltip
						>

							<template slot-scope="scope">
								<div>
									<el-link
											:href="'https://www.ozon.ru/product/'+ scope.row.ozonSku"
											target="_blank"
											type="primary"
									>{{scope.row.name}}</el-link>
								</div>
								<div>{{scope.row.ozonSku}}</div>
								<div>{{scope.row.shopName}}</div>
								<div>{{scope.row.typeName+'('+ scope.row.typeNameCn + ')'}}</div>
							</template>

						</el-table-column>

						<el-table-column
								label="操作"
								:width="110"
								align="center"
						>
							<template slot-scope="scope">
								<template>

									<div>
										<el-button
											type="primary"
											v-if="system == 5"
											@click="clickEdit(scope.row)"
									>编辑</el-button>
									</div>
									<div>
										<el-button
												type="primary"
												v-if="system == 5"
												@click="tongbuItem(scope.row)"
										>同步</el-button>
									</div>

									<div>
										<!--归档状态不显示-->
										<el-button
												type="danger"
												v-if="scope.row.onlineStatus != '6' && system == 5"
												@click="guidangItem(scope.row)"
										>归档</el-button>
									</div>
									<div>
										<!--仅归档状态显示-->
										<el-button
												type="primary"
												v-if="scope.row.onlineStatus == '6' && system == 5"
												@click="qxGuidangItem(scope.row)"
										>取消归档</el-button>
									</div>
									<!--审核中不显示-->
									<el-button
											type="primary"
											icon="el-icon-view"
											v-if="system < 5"
											@click="clickEdit(scope.row,'chakan')"
									>查看</el-button>
								</template>
							</template>
						</el-table-column>
						<el-table-column label="合并数/合并编号/评分" width="180"
										 align="left">
							<template slot-scope="scope">
								<div style="display: flex;flex-direction: column">
									<div v-if="scope.row.mergeNumber" class="item_sku" style="color: #0C88FB;cursor: pointer">
										已合并（{{scope.row.mergeNumber}}）
									</div>
									<div v-if="scope.row.parentSku" class="item_sku" style="margin-top: 3px">
										{{scope.row.parentSku}}
									</div>
									<div v-if="scope.row.rating && scope.row.rating.products && scope.row.rating.products.length >0" class="item_sku" style="margin-top: 3px">
										内容质量分：
										<el-popover trigger="hover" placement="right" v-if="scope.row.rating.products[0].groups && scope.row.rating.products[0].groups.length > 0" :open-delay="400">
											<my-tip ref="myTip" :score="[scope.row.rating.products[0].groups[0],scope.row.rating.products[0].groups[1],scope.row.rating.products[0].groups[2],scope.row.rating.products[0].groups[3]]"></my-tip>
											<span slot="reference" style="margin-left: 3px;color: dodgerblue;cursor: pointer">{{scope.row.rating.products[0].rating }}</span>
										</el-popover>
										<div v-else>
											{{scope.row.rating.products[0].rating}}
										</div>
									</div>
								</div>
							</template>
						</el-table-column>
						<el-table-column prop="title" label="SKU/审核信息" min-width="240"
										 align="center">
							<template slot-scope="scope">
								<div style="display: flex;flex-direction: column">
									<div v-if="scope.row.onlineStatus" class="item_sku">
										<el-tag v-if="scope.row.onlineStatus == 1" type="success">在售</el-tag>
										<el-tag v-if="scope.row.onlineStatus == 2" type="warning">缺货</el-tag>
										<el-tag v-if="scope.row.onlineStatus == 3" type="warning">审核中</el-tag>
										<el-tag v-if="scope.row.onlineStatus == 4" type="danger">失败</el-tag>
										<el-tag v-if="scope.row.onlineStatus == 5">已下架</el-tag>
										<el-tag v-if="scope.row.onlineStatus == 6">归档</el-tag>
									</div>
									<div class="item_sku" style="margin-top: 3px">
										{{scope.row.offerId}}
									</div>
								</div>
							</template>
						</el-table-column>
						<el-table-column prop="title" label="售价/原价" width="180"
										 align="left">
							<template slot-scope="scope">
								<div style="display: flex;flex-direction: column">
									<div v-if="scope.row.price" class="item_sku">
										<el-tag style="line-height: 18px;height: 18px">售</el-tag>	<span style="margin-left: 3px">	{{scope.row.price + '-' + scope.row.currencyCode}}</span>
									</div>
									<div v-if="scope.row.oldPrice" class="item_sku" style="margin-top: 3px">
										<el-tag style="line-height: 18px;height: 18px">原</el-tag>	<span style="margin-left: 3px">	{{scope.row.oldPrice + '-' + scope.row.currencyCode}}</span>
									</div>
									<div v-if="scope.row.premiumPrice" class="item_sku" style="margin-top: 3px">
										<el-tag style="line-height: 18px;height: 18px">低</el-tag>	<span style="margin-left: 3px">{{scope.row.premiumPrice + '-' + scope.row.currencyCode}}</span>
									</div>
								</div>
							</template>
						</el-table-column>
						<el-table-column prop="title" label="库存" width="90"
										 align="left">
							<template slot-scope="scope">
								<div style="display: flex;flex-direction: column;align-items: center;justify-content: center">
									{{scope.row.stock}}
								</div>
							</template>
						</el-table-column>
						<el-table-column prop="title" label="发布/修改/同步时间" width="220"
										 align="left">
							<template slot-scope="scope">
								<div style="display: flex;flex-direction: column">
									<div v-if="scope.row.uploadTime" class="item_sku">
										<el-tag style="line-height: 18px;height: 18px">发</el-tag>	<span style="margin-left: 3px">{{scope.row.uploadTime}}</span>
									</div>
									<div v-if="scope.row.updateTime" class="item_sku" style="margin-top: 3px">
										<el-tag style="line-height: 18px;height: 18px">修</el-tag>	<span style="margin-left: 3px">	{{scope.row.updateTime}}</span>
									</div>
									<div v-if="scope.row.synchronizeTime" class="item_sku" style="margin-top: 3px">
										<el-tag style="line-height: 18px;height: 18px">同</el-tag>	<span style="margin-left: 3px">	{{scope.row.synchronizeTime}}</span>
									</div>
								</div>

							</template>
						</el-table-column>

					</el-table>
					<div class="summary_pagenum_block">
						<div class="block">
							<el-pagination
									@current-change="handleCurrentChange"
									:current-page="currentPage"
									@size-change="handleSizeChange"
									:page-sizes="[10, 20, 50, 100]"
									layout="total, sizes, prev, pager, next, jumper"
									:total="count"
							></el-pagination>
						</div>
					</div>

				</div>
			</div>
		</div>

		<el-dialog
				:title="title"
				:visible.sync="dialogVisible"
				width="90%"
				top="5vh"
		>
			<div v-loading="dialogLoding" ref="dia_box">
				<baseInfo @addToBianti="addToBianti"  @setBiantiList3="setBiantiList3"
						  @editDescJson="editDescJson"  @editShipinDesc="editShipinDesc" @editCangku="editCangku"
						  @changeSku="changeSku"   @changeName="changeName" ref="baseInfo" ></baseInfo>
				<description ref="description"/>
				<shipin ref="shipin"/>
				<wuliu ref="wuliu"/>
				<uploadPictures
						@ImgList="ImgList"
						ref="uploadPictures"
						:page-type="pageType"
						@downloadImgs="downloadImgs"
				/>
				<onlineBianti ref="onlineBianti"  @changeReamrk="changeReamrk"
						:img-select-list="productImgArr" @addImageList="addImageList"/>
			</div>

			<span slot="footer" style="margin-top: 60px">
					<el-button @click="dialogVisible = false">取 消</el-button>
					<el-button type="primary" @click="saveChanpin" v-if="!onlineEdit">保 存</el-button>
					<el-button type="primary" @click="saveAndfabu" style="margin-right: 30px">保存并发布</el-button>
  			</span>
		</el-dialog>
		<el-dialog title="批量编辑" :visible.sync="dialogPiliangEdit"
				   width="70%"
				   top="5vh">
			<!-- 头部 -->
			<el-table
					:data="piliangList"
					style="width: 100%"
					border
					:header-cell-style="iscenter"
					class="pg-table"
					:cell-class-name="'pg-cell'"
					:header-cell-class-name="'pg-header-cell'"
			>
				<el-table-column
						label="图片"
						min-width="20%"
						align="left"
				>
					<template slot-scope="scope">
						<el-popover trigger="hover" placement="right" :open-delay="600">
							<img
									:src="scope.row.primaryImage"
									class="prduct_img"
									alt
							/>
							<div class="scope_img" slot="reference">
								<img
										:src="scope.row.primaryImage"
										alt
								/>
							</div>
						</el-popover>
					</template>
				</el-table-column>
				<el-table-column
						label="ProductId/SKU"
						prop="productNumber"
						align="left"
						show-overflow-tooltip
						min-width="20%"
				>

					<template slot-scope="scope">
						<div>{{scope.row.ozonProductId}}</div>
						<div>{{scope.row.offerId}}</div>
					</template>

				</el-table-column>
				<el-table-column prop="price"
								 min-width="20%"
								 align="left">
					<template slot="header" slot-scope="scope">
					<div class="item_header_title"><span class='item_bitian'>*</span>售价({{bizhong}})</div>
					<div class="item_header_title"><el-link type="primary" @click="clickHeader(scope)" v-if="system == 5">同首行</el-link></div>
						<div class="item_header_title"><el-link type="primary" @click="clickDingjia(scope)" v-if="system == 5">定价计算</el-link></div>
					</template>
					<template slot-scope="scope">
						<el-input v-model="scope.row.price" :disabled="system < 5"
								  oninput ="value=value.replace(/[^\d.]/g, '').replace(/\.{2,}/g, '.').replace('.', '$#$').replace(/\./g, '').replace('$#$', '.').replace(/^(\-)*(\d+)\.(\d\d\d\d\d\d).*$/, '$1$2.$3').replace(/^\./g, '').replace(/^0+(?!\.|$)/g, '')"></el-input>
					</template>
				</el-table-column>
				<el-table-column prop="oldPrice"
								 min-width="20%"
								 align="left">
					<template slot="header" slot-scope="scope">
						<div class="item_header_title"><span class='item_bitian'>*</span>原价({{bizhong}})</div>
						<div class="item_header_title"><el-link type="primary" @click="clickHeader(scope)" v-if="system == 5">同首行</el-link></div>
					</template>
					<template slot-scope="scope">
						<el-input v-model="scope.row.oldPrice" :disabled="system < 5"
								  oninput ="value=value.replace(/[^\d.]/g, '').replace(/\.{2,}/g, '.').replace('.', '$#$').replace(/\./g, '').replace('$#$', '.').replace(/^(\-)*(\d+)\.(\d\d\d\d\d\d).*$/, '$1$2.$3').replace(/^\./g, '').replace(/^0+(?!\.|$)/g, '')"></el-input>
					</template>
				</el-table-column>
				<el-table-column prop="title"
								 min-width="20%"
								 align="left">
					<template slot="header" slot-scope="scope">
						<div class="item_header_title"><span class='item_bitian'>*</span>库存</div>
						<div class="item_header_title"><el-link type="primary" @click="clickHeader(scope)" v-if="system == 5">同首行</el-link></div>
					</template>
					<template slot-scope="scope">
						<el-input v-model="scope.row.stock" :disabled="system < 5" oninput ="value=value.replace(/[^0-9]/g,'')"></el-input>
					</template>
				</el-table-column>
			</el-table>
			<span slot="footer" style="margin-top: 60px">
					<el-button @click="dialogPiliangEdit = false">取 消</el-button>
					<el-button v-if="system == 5 && !isChakan" type="primary" :loading="saveLoadding" @click="editSaveAndfabu" style="margin-right: 30px">保存并发布</el-button>
  			</span>
		</el-dialog>

		<dingjia ref="dingjia" @changeDingjia="changeDingjia"/>
	</div>
</template>

<script>

	let isUpdate = false
	import { Loading } from 'element-ui'
	import { ajaxPost, Baseurl,ajaxGet } from '@/api/api/api'
	import baseInfo from './components/baseInfo.vue'
	import MyTip from './components/myTip.vue'
	import description from "./components/description";
	import shipin from "./components/shipin";
	import wuliu from "./components/wuliu";
	import uploadPictures from "./components/uploadPictures";
	import onlineBianti from "./components/onlineBianti";
	import dingjia from './components/dingjia'
	export default {
		name: 'productDisplay',
		components: {
			baseInfo,
			description,
			shipin,
			wuliu,
			uploadPictures,
			onlineBianti,
			MyTip,
			dingjia
		},
		// beforeRouteEnter(to, from, next) {
		// 	//待定，貌似刷新用的
		// 	// if (from.name == 'editProduct') {
		// 	// 	isUpdate = true
		// 	// } else {
		// 	// 	isUpdate = false
		// 	// }
		// 	// next()
		// },
		data() {
			return {
				isChakan:false,
				saveLoadding:false,
				//选中产品的id
				onlineProductId:'',
				ozonProductId:'',
				dingjiaStatus:'',
				title:'添加产品',
				//在线产品编辑
				onlineEdit:false,
				dialogPiliangEdit:false,
				//批量编辑列表
				piliangList:[],
				resultContent:'',
				//是否为编辑
				isEdit:false,
				bianjiProductId:'',
				loading:null,
				dialogLoding:false,
				batch_select:[],
				productImgArr: [],
				fuzhiId:'',
				//复制店铺的
				fuzhiDianpuObj:{},
				//仓库id
				warehouseId:'',
				//仓库列表
				warehouseIdList:[],
				//选择店铺获得的sellerid
				sellerId:'',
				//选择店铺获得的ShopId
				markShopId:'',
				show:'',
				state:'',
				strSeller:'',
				//标识 1boss 2 部长 3分部长 4 组长 5普通员工
				system:'5',
				//角色id
				rid:'',
				companyInfo: {},
				labelPosition: 'right',

				str: '',
				value2: '',
				//组
				value3: '',
				//员工
				value4: '',
				//店铺
				value5: '',
				//分公司
				value6: '',
				//子公司
				value7: '',
				arr: [],
				arr1: [],
				arr2: [],
				arr3: [],
				arr4: [],
				arr5: [],
				arr6: [],
				arr7: [],
				//平台名称
				sellerType: '',
				disabledInput: '',
				disabledInput2: '',
				disabledInput3: '',
				disabledInput4: '',
				dianpuForm:{},
				selectForm: {
					page: 1,
					size: 20,
					//查询类型
					searchType:'1',
					//查询内容
					searchStr:'',
					startTime: '', //开始时间
					endTime: '', //结束时间
					timeType:1,
					//角色id
					staffId: "",
					//店铺id
					sellerId: "",
					//公司id
					companyId:'',
					onlineStatus: 88,
					isTranslation: 1
				},
				pickerOptions: {
					shortcuts: [{
						text: '本月',
						onClick: (picker) => {
							const date = new Date()
							picker.$emit('pick', date);
							this.calculationDate()
						}
					}, {
						text: '上一月',
						onClick: (picker) => {
							const date = new Date();
							picker.$emit('pick', date);
							this.calculationDate(-1)
						}
					}, {
						text: '上两月',
						onClick: (picker) => {
							const date = new Date();
							picker.$emit('pick', date);
							this.calculationDate(-2)
						}
					}, {
						text: '上三月',
						onClick: (picker) => {
							const date = new Date();
							picker.$emit('pick', date);
							this.calculationDate(-3)
						}
					}]
				},
				branchCompany: [],
				pageType: '',
				dialogVisible:false,
				//提示bug弹窗
				dialogVisibleShenhe:false,
				//复制弹窗
				dialogVisibleFuzhi:false,
				//审核弹窗提示内容
				bugContentList:[],
				tabPosition:'88',
				load_data: false,
				iscenter: {
					textAlign: 'center',
					background: '#f8f8f8',
					color: '#232323',
				},
				currentPage: 1,
				size: 10,
				//page total
				count: 1,
				//已选数量
				piece: 0,
				//是否全选
				checkAll: false,
				tableList: [],
				arrOld: [],
				//公司
				sonCompanyList: [],
				//部门
				departmentList: [],
				//角色
				groupList: [],
				//店铺
				staffList: [],
				loadingStatus: '',
				platform: [
					{"sellerType":1,"itemTypeName":"Amazon"},{"sellerType":2,"itemTypeName":"Shopify"},{"sellerType":5,"itemTypeName":"Shoplazza"},{"sellerType":7,"itemTypeName":"Shopline"}
				],
				platforms:[],
				//选中的列表
				selectTableList:[],
				bizhong:'CNY'
			}
		},
		created() {
			this.dingjiaStatus = ''
			this.sellerId = ''
			this.markShopId = ''
			this.str = JSON.parse(localStorage.getItem('role'))
			this.rid = this.str.rid
			this.selectForm.staffId = this.str.rid
			this.selectForm.companyId = this.str.company_id
			this.strSeller = JSON.parse(localStorage.getItem('sellerInfo'))
			this.show = this.str.system
			this.system = this.str.system
			this.state = this.str.system
			this.init()
			//获取表格数据
			this.get_table_data()
			//不知道
			// ajaxPost(API, paramsData)
			// 		.then((res) => {
			// 			if(res.data.code === 200) {
			// 				this.platforms = res.data.data
			// 			}else{
			// 				this.platform=[]
			// 				this.$message.error(res.data.data)
			// 			}
			// 		})
		},
		methods: {
			init() {
				this.loadingStatus = true
				ajaxPost(Baseurl + 'roleController/selectNextAndSellerInfoByRid', {
					rid: this.str.rid,
					system: this.str.system,
					companyId: this.str.company_id,
					sellerType: this.sellerType
				}).then((res) => {
					this.arr = res.data.data.next
					this.bizhong = (this.arr && this.arr.length > 0 && this.arr[0].currencyCode) ? this.arr[0].currencyCode:'CNY'
					const { type: companyType } = this.str
					if (
							companyType === 1 &&
							this.str.superDepartmentName !== '客服部' &&
							this.str.superDepartmentName !== '常规客服部'
					) {
						this.disabledInput2 = false
						this.disabledInput3 = false
						this.disabledInput4 = false
						this.arr6 = res.data.data.next
					} else if (
							companyType === 2 ||
							(companyType === 1 &&
									this.str.superDepartmentName === '客服部') ||
							(companyType === 1 &&
									this.str.superDepartmentName === '常规客服部')
					) {
						this.disabledInput2 = false
						this.disabledInput3 = false
						this.disabledInput4 = false
						this.arr7 = res.data.data.next
					} else if (
							this.state === 1 ||
							(this.str.type === 3 &&
									this.str.system === 5 &&
									this.str.superDepartmentName === '财务部') ||
							(this.str.type === 3 &&
									this.str.system === 5 &&
									this.str.superDepartmentName === '人事部')
					) {
						this.disabledInput = false
						this.disabledInput2 = false
						this.disabledInput3 = false
						this.disabledInput4 = false
						this.arr1 = res.data.data.next
					} else if (this.state === 2) {
						this.disabledInput = true
						this.disabledInput2 = false
						this.disabledInput3 = false
						this.disabledInput4 = false
						this.arr1 = res.data.data.next
					} else if (this.state === 3) {
						this.disabledInput = true
						this.disabledInput2 = true
						this.disabledInput3 = false
						this.disabledInput4 = false
						this.arr2 = res.data.data.next
					} else if (this.state === 4) {
						this.disabledInput = true
						this.disabledInput2 = true
						this.disabledInput3 = true
						this.disabledInput4 = false
						this.arr3 = res.data.data.next
					} else if (this.state === 5) {
						this.disabledInput = true
						this.disabledInput2 = true
						this.disabledInput3 = true
						this.disabledInput4 = true
						var sellerInfos = res.data.data.next
						var newArr = []
						var num = 0
						for (var i = 0; i < sellerInfos.length; i++) {
							var shop = sellerInfos[i].countryMarks
							var sellerId = sellerInfos[i].sellerId
							for (var j = 0; j < shop.length; j++) {
								shop[j].sellerId = sellerId
								newArr[num] = shop[j]
								// newArr[num] = shop[j];
								num++
							}
						}
						this.arr4 = newArr
						// this.arr4 = newArr.sort((a, b) => a.order - b.order);
					}
				})
			},
			calculationDate(type = 0) {
				const date = new Date()
				const year = date.getFullYear()
				const month = date.getMonth() + 1
				const day = date.getDate()
				// 计算新的月份和年份，确保处理负数和跨年的情况
				const newYear = year + Math.floor((month + type - 1) / 12);
				const newMonth = (month + type - 1 + 12) % 12 + 1;
				this.selectForm.startTime = `${newYear}-${newMonth.toString().padStart(2, '0')}-01 00:00:00`;

				const prevStamp = new Date(year, month + type, day).getTime() - (3600 * 1000 * 24 * day)
				const prevMonth = `${new Date(prevStamp).getFullYear()}-${new Date(prevStamp).getMonth() + 1}-${new Date(prevStamp).getDate()}`
				this.selectForm.endTime = `${prevMonth} 23:59:59`
			},
			//获取表格数据
			get_table_data() {
				var that = this
				this.load_data = true
				var begin = this.selectForm.startTime
				if (begin == null || begin == '') {
					begin = ''
				} else {
					begin =
							new Date(this.selectForm.startTime)
									.toLocaleDateString()
									.replace(/\//g, '-') +
							' ' +
							new Date(this.selectForm.startTime)
									.toTimeString()
									.substr(0, 8)
				}
				var end = this.selectForm.endTime
				if (end == null || end == '') {
					end = ''
				} else {
					end =
							new Date(this.selectForm.endTime)
									.toLocaleDateString()
									.replace(/\//g, '-') +
							' ' +
							new Date(this.selectForm.endTime).toTimeString().substr(0, 8)
				}
				this.loadingStatus = true
				//将startTime格式强转
				let searchobj  =Object.assign({}, this.selectForm, {
					startTime:begin,
					endTime:end,
					page: this.currentPage,
					size: this.size,
				})
				ajaxPost(Baseurl + 'ozonProductVariant/selectOzonOnlineProducts', searchobj).then(
						(res) => {
							this.load_data = false
							const { code, message, data } = res.data
							if (code == 200) {
								this.tableList = data.list.map(item => {
									item.isShowAll = false
									item.images = JSON.parse(item.images)
									item.rating = JSON.parse(item.rating)
									return item
								})
								this.count = data.total
							} else {
								this.$message.error(message)
							}
						}
				).catch(function(e) {
				})
			},
			// 条件搜索
			search() {
				this.currentPage = 1
				this.get_table_data()
			},
			//下拉选变化
			selectChange(event, type) {
				if (type === 'sonCompanyList') {
				} else if (type === 'departmentList') {
				} else if (type === 'groupList') {
				} else if (type === 'staffList') {
				}
			},
			//重置
			resetForm(formName) {
				this.$refs[formName].resetFields()
				this.sonCompany = []
				this.departmentList = []
				this.groupList = []
				this.staffList = []
				this.get_table_data()
			},
			//修改size
			handleSizeChange(val) {
				this.size = val
				this.get_table_data()
			},
			//修改current
			handleCurrentChange(val) {
				this.currentPage = val
				this.get_table_data()
			},
			// 选中框
			Selection(item) {
				this.arrOld.push(item.id)
				if (item.chatype) {
					this.piece++
				} else {
					this.piece--
				}
				if (this.tableList.length > this.piece) {
					this.checkAll = false
				} else {
					this.checkAll = true
				}
			},
			//左侧勾选项变化
			on_batch_select(val) {
				var newarr = []
				this.piece = val.length
				for (var i = 0; i < val.length; i++) {
					newarr.push(val[i].id)
				}
				this.batch_select = newarr
				this.selectTableList = val
				// this.batch_select = val;
			},
			//审核提示
			clickBugTip(val){
				this.bugContentList = val
				this.dialogVisibleShenhe = true
			},
			//重置各页面参数
			resetPage(){
				this.$refs.baseInfo.formData.shopId = undefined
				this.$refs.baseInfo.formData.sellerId = undefined
				this.$refs.baseInfo.formData.name = undefined
				this.$refs.baseInfo.allLeimuName = undefined
				this.$refs.baseInfo.formData.sku = undefined
				this.$refs.baseInfo.formData.categoryId = undefined
				this.$refs.baseInfo.formData.typeId = undefined
				this.$refs.description.formData.descValue = undefined
				this.$refs.description.formData.description = undefined
				this.$refs.description.formData.jsonDescription = undefined
				this.$refs.description.formData.jsonValue = undefined
				this.$refs.description.formData.chicunDescription = undefined
				this.$refs.description.formData.chicunValue = undefined
				this.$refs.description.isShowJson = false
				this.$refs.description.isShowChicun = false
				this.$refs.shipin.formData.title = undefined
				this.$refs.shipin.formData.biaotiDescription = undefined
				this.$refs.shipin.formData.chanpinDescription = undefined
				this.$refs.shipin.formData.fengmianDescription = undefined
				this.$refs.shipin.chanpinUrl = ''
				this.$refs.shipin.fengmianUrl = ''
				this.$refs.uploadPictures.imgListSelect = []
				this.$refs.wuliu.formData.depth = undefined
				this.$refs.wuliu.formData.height = undefined
				this.$refs.wuliu.formData.vat = '0'
				this.$refs.wuliu.formData.weight = undefined
				this.$refs.wuliu.formData.width = undefined
				this.$refs.wuliu.formData.warehouseId = undefined
				this.$refs.onlineBianti.ParentSKU = undefined
				this.$refs.onlineBianti.ParentName = undefined
				this.$refs.onlineBianti.bizhong = this.bizhong
				this.$refs.onlineBianti.tableList =[{
					name:'',
					oldPrice:'',//原价
					price:'',//现价
					stock:'',//库存
					isShowImage:false,//是否展示输入框按钮
					offerId:'',//卖家产品id(自定义sku) 父sku拼接颜色/尺寸等
					primaryImage:'', //主图
					imageList:[],
					colorImage:'',//营销色彩
				}]
				this.$refs.onlineBianti.headerList =[]

			},
			//复制产品
			copyProduc(row){
				if (!row && this.piece == 0){
					this.$alert('请至少勾选一件产品！', '提示', {
						confirmButtonText: '确定',
					})
					return
				}
				if (row){
					this.fuzhiId = row.id
				} else {
					this.fuzhiId = ''
				}
				this.fuzhiDianpuObj = {}
				this.warehouseId = ''
				this.dialogVisibleFuzhi = true
			},
			//删除产品
			deleteProduct(row){
				var that = this
				if (this.piece == 0 && !row) {
					this.$alert('请至少勾选一件产品！', '提示', {
						confirmButtonText: '确定',
					})
				} else {
					this.$confirm('此操作将永久删除该产品, 是否继续?', '提示', {
						confirmButtonText: '确定',
						cancelButtonText: '取消',
						type: 'warning',
					})
							.then(() => {
								let params ={
									ids: row ? [row.id]:that.batch_select
								}
								ajaxPost(
										Baseurl + 'ozonProduct/batchDeleteOzonProduct',
										params
								).then((res) => {
									if (res.data.code == 200) {
										that.$message({
											type: 'success',
											message: '删除成功!',
										})
										that.get_table_data()
									}
								})
							})
							.catch(() => {
								this.$message({
									type: 'info',
									message: '已取消删除',
								})
							})
				}
			},
			//发布产品
			displayProduc(row){
				var that = this
				if (this.piece == 0 && !row) {
					this.$alert('请至少勾选一件产品！', '提示', {
						confirmButtonText: '确定',
					})
				} else {
					this.$confirm('此操作将发布产品, 是否继续?', '提示', {
						confirmButtonText: '确定',
						cancelButtonText: '取消',
						type: 'warning',
					})
							.then(() => {
								ajaxPost(
										Baseurl + 'ozonProduct/batchReleaseOzonProduct',
										{
											ids: row ? [row.id]:that.batch_select
										}
								).then((res) => {
									if (res.data.code == 200) {
										that.$message({
											type: 'success',
											message: '删除成功!',
										})
										that.get_table_data()
									}
								})
							})
							.catch(() => {
								this.$message({
									type: 'info',
									message: '已取消删除',
								})
							})
				}
			},
			//同步产品
			tbProduc(row){
				var that = this
				if (this.piece == 0 && !row) {
					this.$alert('请至少勾选一件产品！', '提示', {
						confirmButtonText: '确定',
					})
				} else {
					//这里应该写一个状态不一致的判断逻辑并给提示
					// if (!row){
					//
					// }

					this.$confirm('此操作将同步产品该产品, 是否继续?', '提示', {
						confirmButtonText: '确定',
						cancelButtonText: '取消',
						type: 'warning',
					})
							.then(() => {
								ajaxPost(
										Baseurl + 'ozonProduct/batchDeleteOzonProduct',
										{
											ids: row ? [row.id]:that.batch_select
										}
								).then((res) => {
									if (res.data.code == 200) {
										that.$message({
											type: 'success',
											message: '同步成功!',
										})
										that.get_table_data()
									}
								})
							})
							.catch(() => {
								this.$message({
									type: 'info',
									message: '已取消删除',
								})
							})
				}
			},
			// 产品图片子组件 中上传的图片列表
			ImgList(ImgList) {
				this.productImgArr = ImgList
			},
			downloadImgs() {
				const API =
						Baseurl + 'imageController/downlowndImage?id=' + this.productId
				ajaxPost(API)
						.then((res) => {
							const { code, data } = res.data
							if (code === 200) {
								const AElement = document.createElement('a')
								AElement.href = data
								AElement.click()
								this.$message.success('正在下载...')
							}
						})
						.catch(() => {
							this.$message.error('下载失败...')
						})
			},
			//增加变体信息
			addToBianti(item){
				this.$refs.onlineBianti.addBianti(item)
			},
			//设置变体信息
			setBiantiList3(list1,list2) {
				this.$refs.onlineBianti.setBiantiList3(list1,list2)
			},
			editDescJson(item,type){
				this.$refs.description.editDescJson(item,type)
			},
			editShipinDesc(item,type){
				this.$refs.shipin.editSpDesc(item,type)
			},
			//修改仓库list
			editCangku(arr){
				this.$refs.wuliu.editCangku(arr)
			},
			shopChange2(value2) {
				this.arr3 = []
				this.arr4 = []
				this.arr5 = []
				this.value3 = ''
				this.value4 = ''
				this.value5 = ''
				this.rid = value2.rid
				ajaxPost(Baseurl + 'roleController/selectNextAndSellerInfoByRid', {
					rid: value2.rid,
					system: 3,
					companyId: this.selectForm.companyId,
					sellerType: this.sellerType
				}).then((res) => {
					this.arr2 = res.data.data.next
					this.shopIds = res.data.data.shopIds
				})
			},
			shopChange3(value3) {
				this.arr4 = []
				this.arr5 = []
				this.value4 = ''
				this.value5 = ''
				this.rid = value3.rid
				ajaxPost(Baseurl + 'roleController/selectNextAndSellerInfoByRid', {
					rid: value3.rid,
					system: 4,
					companyId: this.selectForm.companyId,
					sellerType: this.sellerType
				}).then((res) => {
					this.arr3 = res.data.data.next
					this.shopIds = res.data.data.shopIds
				})
			},
			shopChange4(value4) {
				this.arr5 = []
				this.value5 = ''
				this.rid = value4.rid
				ajaxPost(Baseurl + 'roleController/selectNextAndSellerInfoByRid', {
					rid: value4.rid,
					system: 5,
					companyId: this.selectForm.companyId,
					sellerType: this.sellerType
				}).then((res) => {
					var sellerInfos = res.data.data.next
					var newArr = []
					var ids = []
					var num = 0
					for (var i = 0; i < sellerInfos.length; i++) {
						var shop = sellerInfos[i].countryMarks
						for (var j = 0; j < shop.length; j++) {
							newArr[num] = shop[j]
							ids[num] = shop[j].shopId
							num++
						}
					}
					this.arr4 = newArr
					this.shopIds = res.data.data.shopIds
				})
			},
			shopChange5(value5) {
				// this.sellerIds = item;
				// this.rid = ''
				this.shopIds = [value5.shopId]
				this.markShopId =value5.shopId
				this.selectForm.sellerId = value5.sellerId
			},
			shopChange6(value6) {
				this.arr1 = []
				this.arr2 = []
				this.arr3 = []
				this.arr4 = []
				this.arr5 = []
				this.arr7 = []
				this.value1 = ''
				this.value2 = ''
				this.value3 = ''
				this.value4 = ''
				this.value5 = ''
				this.value7 = ''
				this.selectForm.companyId = value6.company_id
				this.rid = value6.rid
				ajaxPost(Baseurl + 'roleController/selectNextAndSellerInfoByRid', {
					rid: value6.rid,
					system: 1,
					companyId: this.selectForm.companyId,
					sellerType: this.sellerType
				}).then((res) => {
					const { code, data } = res.data
					if (code === 200) {
						this.arr7 = data.next
						this.shopIds = data.shopIds
						this.getCompanyMoney()
					}
				})
			},
			shopChange7(value7) {
				this.arr1 = []
				this.arr2 = []
				this.arr3 = []
				this.arr4 = []
				this.arr5 = []
				this.value1 = ''
				this.value2 = ''
				this.value3 = ''
				this.value4 = ''
				this.value5 = ''
				this.selectForm.companyId = value7.company_id
				this.sellerType='';
				this.rid = value7.rid
				ajaxPost(Baseurl + 'roleController/selectNextAndSellerInfoByRid', {
					rid: value7.rid,
					system: 1,
					companyId: this.selectForm.companyId,
					sellerType: this.sellerType
				}).then((res) => {
					const { code, data } = res.data
					if (code === 200) {
						this.arr1 = data.next
						this.shopIds = data.shopIds
						this.getCompanyMoney()
					}
				})
				this.getItemList();
			},
			shopChange8() {
				// if(this.arr4.length != 0) {
				ajaxPost(Baseurl + 'roleController/selectNextAndSellerInfoByRid', {
					rid: this.rid,
					system: this.str.system,
					companyId: this.selectForm.companyId,
					sellerType: this.sellerType
				}).then((res) => {
					// var sellerInfos = res.data.data.next
					// var newArr = []
					// var ids = []
					// var num = 0
					// for (var i = 0; i < sellerInfos.length; i++) {
					// 	var shop = sellerInfos[i].countryMarks
					// 	for (var j = 0; j < shop.length; j++) {
					// 		newArr[num] = shop[j]
					// 		ids[num] = shop[j].shopId
					// 		num++
					// 	}
					// }
					if (
							this.state === 1 ||
							(this.str.type === 3 &&
									this.str.system === 5 &&
									this.str.superDepartmentName === '财务部') ||
							(this.str.type === 3 &&
									this.str.system === 5 &&
									this.str.superDepartmentName === '人事部')
					) {
						this.arr1 = res.data.data.next
						this.arr2 = []
						this.arr3 = []
						this.arr4 = []
						this.arr5 = []
						this.value2 = ''
						this.value3 = ''
						this.value4 = ''
						this.value5 = ''
					} else if(this.state === 2) {
						this.arr1 = res.data.data.next
						this.arr2 = []
						this.arr3 = []
						this.arr4 = []
						this.arr5 = []
						this.value2 = ''
						this.value3 = ''
						this.value4 = ''
						this.value5 = ''
					}else if(this.state === 3) {
						this.arr2 = res.data.data.next
						this.arr3 = []
						this.arr4 = []
						this.arr5 = []
						this.value3 = ''
						this.value4 = ''
						this.value5 = ''
					}else if(this.state === 4) {
						this.arr3 = res.data.data.next
						this.arr4 = []
						this.arr5 = []
						this.value4 = ''
						this.value5 = ''
					}else if(this.state === 5) {
						var sellerInfos = res.data.data.next
						var newArr = []
						var num = 0
						for (var i = 0; i < sellerInfos.length; i++) {
							var shop = sellerInfos[i].countryMarks
							for (var j = 0; j < shop.length; j++) {
								newArr[num] = shop[j]
								// newArr[num] = shop[j];
								num++
							}
						}
						this.arr4 = newArr
						this.arr5 = []
						this.value5 = ''
					}
					this.shopIds = res.data.data.shopIds
				})
				// }
			},

			Search2() {
				this.currentPage = 1
				this.get_table_data()
			},
			// 重置
			searchReset() {
				this.selectForm.startTime = undefined
				this.selectForm.endTime = undefined
				this.selectForm.searchStr = undefined
				this.selectForm.searchType = '1'
				this.selectForm.sellerId = ''
				this.input = ''
				this.selectForm.Ymxvalue = ''
				this.selectForm.demandValue = ''
				this.selectForm.purchaseValue = ''
				this.selectForm.domesticvalue = ''
				this.selectForm.domesticLogisticsStatus = ''
				this.selectForm.internationalLogisticsStatus = ''
				this.selectForm.purchaseEstimated = ''
				this.selectForm.logisticsEstimated = ''
				this.selectForm.channelStatus = ''
				this.selectForm.countryMark = ''
				// this.selectForm.startTime = ''
				// this.selectForm.endTime = ''
				this.selectForm.systemSku = ''
				this.selectForm.sku = ''

				this.selectForm.resource1 = ''
				this.selectForm.resource2 = ''
				this.selectForm.resource3 = ''
				this.selectForm.resource4 = ''
				;(this.purchaseMark = ''),
						(this.channelMark = ''),
						(this.orderMark = '')
				this.orderType = '';
				this.currentPage = 1
				this.size = 20
				this.arr1 = []
				this.arr2 = []
				this.arr3 = []
				this.arr4 = []
				this.arr5 = []
				this.arr6 = []
				this.arr7 = []
				// this.value1 = "";
				this.value2 = ''
				this.value3 = ''
				this.value4 = ''
				this.value5 = ''
				this.value6 = ''
				this.value7 = ''
				this.sellerType = ''

				this.orderStatus = ''
				this.purchaseDemandStatus = ''

				this.selectForm.internalConveyNumber = ''
				this.selectForm.conveyNumber = ''

				var str = JSON.parse(localStorage.getItem('role'))
				this.state = str.system
				this.rid = str.rid
				this.init()
				this.get_table_data()
			},
			getCompanyMoney() {
				const API =
						Baseurl + 'companyController/selectCompanyBalanceByCompanyId'
				const paramsData = { id: this.selectForm.companyId }

				ajaxPost(API, paramsData).then((res) => {
					const { code, data } = res.data
					if (code === 200) {
						this.companyInfo = data
					}
				})
			},

			//选择开始时间
			startTime(val) {
				var d = new Date(val)
				var datetime =
						d.getFullYear() +
						'-' +
						(d.getMonth() + 1) +
						'-' +
						d.getDate() +
						' 00:00:00'
				this.selectForm.startTime = datetime
			},
			// 选择结束时间
			endTime(val) {
				var d = new Date(val)
				var datetime =
						d.getFullYear() +
						'-' +
						(d.getMonth() + 1) +
						'-' +
						d.getDate() +
						' 23:59:59'
				this.selectForm.endTime = datetime
			},
			//修改状态，请求数据接口
			changeStatus(){
				this.currentPage = 1
				this.get_table_data()
			},
			clickFuzhi(){
				this.dialogVisibleFuzhi = false
				this.load_data = true
				var that = this
				let params ={
					ids: that.fuzhiId? [that.fuzhiId]: that.batch_select,
					sellerId: that.fuzhiDianpuObj.sellerId,
					countrySellerId:that.fuzhiDianpuObj.shopId,
					warehouseId:that.warehouseId
				}
				ajaxPost(Baseurl + 'ozonProduct/copyOzonProduct', params).then((res) => {
					this.load_data = false
					if (res.data.code == 200) {
						this.$message({
							type: 'success',
							message: '复制成功!',
						})
						this.get_table_data()
					} else {
						this.$message({
							type: 'error',
							message: res.data.message,
						})
					}
				})
			},
			changeDianpuId(val){
				if (val){
					this.warehouseIdList = []
					this.fuzhiDianpuObj = val
					//通过商铺id获取仓库雷柏
					const API =
							Baseurl + 'ozonProduct/getOzonWarehouseList'
					const paramsData = { sellerId: val.sellerId}
					ajaxPost(API, paramsData).then((res) => {
						const { code, data } = res.data
						if (code === 200) {
							this.warehouseIdList = data
						}
					})
				} else {
					this.fuzhiDianpuObj = {}
					this.warehouseId = ''
					this.warehouseIdList = []
				}
			},	// 产品图片子组件 响应 变体信息子组件 中上传的图片
			addImg(file) {
				this.$refs.uploadPictures.addImg(file)
			},
			addImageList(imageList){
				this.$refs.uploadPictures.biantiaddImgList(imageList)
			},
			//修改reamrk
			changeReamrk(val){
			},
			//子项点击移除变体
			changeTopAttr(attrList){
				this.$refs.baseInfo.addTopAttrList(attrList)
			},
			//保存按钮
			saveChanpin(){
				this.saveLoadding = true
				//获取精细化标题
				this.$refs.onlineBianti.createName()
				let attributesJsonArray = this.$refs.baseInfo.topAttributeList.map(item =>{
					let isZhi = false
					let values = []
					//输入框
					if(item.dictionaryId == 0){
						if (item.fieldValue || item.fieldValue == '0' || item.fieldValue == 'false' ){
							isZhi = true
							if (item.type == 'Boolean'){
								values= [{value:item.fieldValue == true ? true:false}]
							} else if (item.type == 'Integer'){
								values= [{value:parseInt(item.fieldValue)}]
							} else if(item.type == 'Decimal'){
								values= [{value:parseFloat(item.fieldValue)}]
							} else {
								values= [{value:item.fieldValue}]
							}
						} else {
							isZhi = false
							values = []
						}
					}
					//单选
					if (item.dictionaryId != 0 && item.isCollection == 0){
						if (item.fieldValue || item.fieldValue == '0'){
							isZhi = true
							let valueObj = item.attributeValues.filter(itemattrs =>{
								return itemattrs.value == item.fieldValue
							})[0]
							values = [
								{
									dictionary_value_id:valueObj.valueId,
									value:valueObj.value
								}
							]
						} else {
							isZhi = false
							values = []
						}

					}
					//多选
					if (item.dictionaryId != 0 && item.isCollection == 1){
						if (item.fieldValue && item.fieldValue.length > 0){
							let ss = []
							item.attributeValues.forEach(itemattrs =>{
								if (item.fieldValue.some(iiField =>
										iiField == itemattrs.value
								)){
									ss.push(
											{
												dictionary_value_id:itemattrs.valueId,
												value:itemattrs.value
											}
									)
								}
							})
							values = ss
							isZhi = true
						} else {
							isZhi = false
							values = []
						}

						// values = [
						// 	{
						// 		dictionary_value_id:valueObj.valueId,
						// 		value:valueObj.value
						// 	}
						// ]
					}
					if (item.attributeId == '31' || item.attributeId == '85'){
						values=[{
							dictionary_value_id:'126745801',
							value:'Нет бренда'
						}]
					}
					if (item.attributeId == '33'){
						values=[{
							dictionary_value_id:'10079056',
							value:'Без серии'
						}]
					}
					return {
						complex_id: item.attributeComplexId,
						id: item.attributeId, //属性id
						isZhi:isZhi,
						values:values
					}
				})
				//baseInfo 有9048属性
				if (this.$refs.baseInfo.attr9048 && this.$refs.baseInfo.attr9048.attributeId){
					attributesJsonArray.push({
						complex_id: this.$refs.baseInfo.attr9048.attributeComplexId,
						id: this.$refs.baseInfo.attr9048.attributeId, //属性id
						isZhi:true,
						values:[{
							value:this.$refs.baseInfo.formData.sku
						}]
					})
				}
				//baseInfo 有8292属性
				if (this.$refs.baseInfo.attr8292 && this.$refs.baseInfo.attr8292.attributeId){
					attributesJsonArray.push({
						complex_id: this.$refs.baseInfo.attr8292.attributeComplexId,
						id: this.$refs.baseInfo.attr8292.attributeId, //属性id
						isZhi:true,
						values:[{
							value:this.$refs.baseInfo.formData.sku
						}]
					})
				}
				let saveArr = attributesJsonArray.filter(item =>{
					return item.isZhi
				})
				//封面视频
				if (this.$refs.shipin.fengmianUrl){
					saveArr.push({
						complex_id: this.$refs.baseInfo.biaotiComplexId21845,
						id: 21845,
						values:[{value:this.$refs.shipin.fengmianUrl}]
					})
				}
				//产品视频
				if (this.$refs.shipin.chanpinUrl){
					saveArr.push({
						complex_id: this.$refs.baseInfo.biaotiComplexId21841,
						id: 21841,
						values:[{value:this.$refs.shipin.chanpinUrl}]
					})
				}
				//视频标题
				if (this.$refs.shipin.formData.title){
					saveArr.push({
						complex_id: this.$refs.baseInfo.biaotiComplexId21837,
						id: 21837,
						values:[{value:this.$refs.shipin.formData.title}]
					})
				}
				//文字描述 简介
				if (this.$refs.description.formData.descValue){
					saveArr.push({
						complex_id:this.$refs.baseInfo.biaotiComplexId4191,
						id: 4191,
						values:[{value:this.$refs.description.formData.descValue}]
					})
				}
				//尺寸表
				if (this.$refs.description.formData.chicunValue){
					saveArr.push({
						complex_id: this.$refs.baseInfo.biaotiComplexId13164,
						id: 13164,
						values:[{value:this.$refs.description.formData.chicunValue}]
					})
				}
				//丰富内容
				if (this.$refs.description.formData.jsonValue){
					saveArr.push({
						complex_id: this.$refs.baseInfo.biaotiComplexId11254,
						id: 11254,
						values:[{value:this.$refs.description.formData.jsonValue}]
					})
				}
				let biantiAttributesArr = this.$refs.onlineBianti.headerList.map(item =>{
					let isZhi = false
					let values = []
					//输入框
					if(item.dictionaryId == 0){
						if (item.fieldValue || item.fieldValue == '0' || item.fieldValue == 'false' ){
							isZhi = true
							if (item.type == 'Boolean'){
								values= [{value:item.fieldValue == true ? true:false}]
							} else if (item.type == 'Integer'){
								values= [{value:parseInt(item.fieldValue)}]
							} else if(item.type == 'Decimal'){
								values= [{value:parseFloat(item.fieldValue)}]
							} else {
								values= [{value:item.fieldValue}]
							}
						} else {
							isZhi = false
							values = []
						}
					}
					//单选
					if (item.dictionaryId != 0 && item.isCollection == 0){
						if (item.fieldValue || item.fieldValue == '0'){
							isZhi = true
							let valueObj = item.attributeValues.filter(itemattrs =>{
								return itemattrs.value == item.fieldValue
							})[0]
							values = [
								{
									dictionary_value_id:valueObj.valueId,
									value:valueObj.value
								}
							]
						} else {
							isZhi = false
							values = []
						}

					}
					//多选
					if (item.dictionaryId != 0 && item.isCollection == 1){
						if (item.fieldValue && item.fieldValue.length > 0){
							let ss = []
							item.attributeValues.forEach(itemattrs =>{
								if (item.fieldValue.some(iiField =>
										iiField == itemattrs.value
								)){
									ss.push(
											{
												dictionary_value_id:itemattrs.valueId,
												value:itemattrs.value
											}
									)
								}
							})
							values = ss
							isZhi = true
						} else {
							isZhi = false
							values = []
						}

						// values = [
						// 	{
						// 		dictionary_value_id:valueObj.valueId,
						// 		value:valueObj.value
						// 	}
						// ]
					}
					return {
						complex_id: item.attributeComplexId,
						id: item.attributeId, //属性id
						isZhi:isZhi,
						values:values
					}
				}).filter((itemFilter=>{
					return itemFilter.isZhi
				}))
				let saveAspectAttributesJsonArray = saveArr.concat(biantiAttributesArr)
				let saveParams ={
					id: this.onlineProductId, //产品变体id
					name: this.$refs.onlineBianti.tableList[0].name, //产品名称,标题 精细化后的
					aspectAttributesJsonArray: saveAspectAttributesJsonArray, //在线产品所有属性
					offerId: this.$refs.onlineBianti.tableList[0].offerId, //卖家产品id(自定义sku) 父sku拼接颜色/尺寸等
					ozonProductId: this.ozonProductId, //ozon产品id
					oldPrice: parseFloat(this.$refs.onlineBianti.tableList[0].oldPrice), //原价
			//		premiumPrice: 120.88, //订阅客户价格
					price: parseFloat(this.$refs.onlineBianti.tableList[0].price), //现价 BigDecimal
					stock:parseInt(this.$refs.onlineBianti.tableList[0].stock), //库存 Integer
					sellerId: this.$refs.baseInfo.formData.sellerId, //卖家id
					warehouseId: this.$refs.wuliu.formData.warehouseId
				}
				let apiUrl = 'ozonProductVariant/updateAndReleaseOnlineProduct'
				ajaxPost(Baseurl + apiUrl, saveParams).then(
						(res) => {
							const { code, message, data } = res.data
							if (code == 200) {
								this.$message.success('发布成功！')
								this.saveLoadding = false
								this.dialogVisible = false
								this.get_table_data()
							} else {
								this.$message.error(message)
							}
						}
				).catch(function(e) {
				})
			},
			//返回数字或者null
			returnNumber(val){
				if (val) {
					return parseFloat(val); // 返回数字
				} else {
					return null; // 返回null
				}
			},
			clickEdit(row,type){
				this.saveLoadding = true
				this.onlineProductId = row.id
				this.ozonProductId = row.ozonProductId
				this.title = type == 'chakan' ? '查看产品':'编辑产品'
				this.isEdit = true
				this.dialogVisible = true
				this.onlineEdit = true
				this.dialogLoding = true
				const API = Baseurl + 'ozonProductVariant/getOzonOnlineProductInfo'
				let params = {
					ozonProductId: row.ozonProductId,
					offerId: row.offerId,
					sellerId: row.sellerId
				}

				let cangkuParams = {
					sellerId: row.sellerId
				}
				//获取仓库列表
				this.getCangku(cangkuParams)
				ajaxPost(API, params)
						.then((res) => {
							if(res.data.code === 200) {
								this.resetPage()
								let dianpuParams ={
									rid: this.str.rid,
									system: this.str.system,
									companyId: this.str.company_id,
									sellerType: ''
								}

								//获取店铺列表
								this.$refs.baseInfo.getdianpuList(dianpuParams)

								this.$refs.baseInfo.onlineEdit = true
								this.$refs.baseInfo.formData.sku = row.parentSku
								this.$refs.onlineBianti.ParentSKU = row.parentSku
								this.$refs.baseInfo.allLeimuName = row.typeName + '('+row.typeNameCn +')'
								this.$refs.baseInfo.formData.categoryId = row.categoryId
								this.$refs.baseInfo.formData.typeId = row.typeId
								this.$refs.baseInfo.formData.sellerId = row.sellerId
								this.$refs.baseInfo.formData.name = row.name

								this.$refs.uploadPictures.imgListSelect = row.images
								this.productImgArr = row.images
								this.$refs.wuliu.formData.warehouseId = row.warehouseId
								this.selectForm.staffId = row.staffId
								this.$refs.baseInfo.formData.shopId = row.countrySellerId
								this.$refs.baseInfo.formData.sellerId = row.sellerId
								this.$refs.onlineBianti.ParentSKU = row.parentSku
								this.$refs.onlineBianti.ParentName = row.name
								this.selectForm.companyId = row.companyId

								this.$refs.onlineBianti.ParentName = row.name
								this.$refs.onlineBianti.tableList[0].offerId = row.offerId
								this.$refs.onlineBianti.tableList[0].oldPrice = res.data.data.productInfo.old_price//原价
								this.$refs.onlineBianti.tableList[0].price = res.data.data.productInfo.price//现价
								this.$refs.onlineBianti.tableList[0].stock = parseInt(res.data.data.productInfo.stocks.coming) + parseInt(res.data.data.productInfo.stocks.present) +parseInt(res.data.data.productInfo.stocks.reserved) //库存
								this.$refs.onlineBianti.tableList[0].imageList = res.data.data.productInfo.images
								if (res.data.data && res.data.data.productAttributesInfo
										&& res.data.data.productAttributesInfo.length > 0){
									let productAttributesInfo = res.data.data.productAttributesInfo[0]
									this.$refs.wuliu.formData.depth = productAttributesInfo.depth
									this.$refs.wuliu.formData.dimensionUnit = productAttributesInfo.dimension_unit
									this.$refs.wuliu.formData.height = productAttributesInfo.height
									if (res.data.data.productInfo.vat == '0.100000'){
										this.$refs.wuliu.formData.vat = '0.1'
									} else if (res.data.data.productInfo.vat == '0.200000'){
										this.$refs.wuliu.formData.vat = '0.2'
									} else if(res.data.data.productInfo.vat == '0.0'){
										this.$refs.wuliu.formData.vat = '0'
									}

									this.$refs.wuliu.formData.weight = productAttributesInfo.weight
									this.$refs.wuliu.formData.weightUnit = productAttributesInfo.weight_unit
									this.$refs.wuliu.formData.width = productAttributesInfo.width

									if (type == 'chakan'){
										this.isChakan = true
										this.$refs.baseInfo.isChakan = true
										this.$refs.description.isChakan = true
										this.$refs.laiyuan.isChakan = true
										this.$refs.shipin.isChakan = true
										this.$refs.wuliu.isChakan = true
										this.$refs.onlineBianti.isChakan = true
										this.$refs.uploadPictures.isChakan = true
									} else {
										this.isChakan = false
										this.$refs.baseInfo.isChakan = false
										this.$refs.description.isChakan = false
										this.$refs.laiyuan.isChakan = false
										this.$refs.shipin.isChakan = false
										this.$refs.wuliu.isChakan = false
										this.$refs.onlineBianti.isChakan = false
										this.$refs.uploadPictures.isChakan = false
									}
									//变体属性
								//	let productInfo = res.data.data.productInfo
									let zhuAttributes = res.data.data.productAttributesInfo[0].attributes
									zhuAttributes.forEach(item => {
										//封面视频
										if (item.attribute_id == '21845'){
											this.$refs.shipin.fengmianUrl = item.values[0].value
										}
										//产品视频
										if (item.attribute_id == '21841'){
											this.$refs.shipin.chanpinUrl = item.values[0].value
										}
										//视频标题
										if (item.attribute_id == '21837'){
											this.$refs.shipin.title = item.values[0].value
										}
										//文字描述
										if (item.attribute_id == '4191'){
											this.$refs.description.formData.descValue = item.values[0].value
										}
										//尺寸表
										if (item.attribute_id == '13164'){
											this.$refs.description.formData.chicunValue = item.values[0].value
										}
										//丰富内容
										if (item.attribute_id == '11254'){
											this.$refs.description.formData.jsonValue = item.values[0].value
										}
									})
									//	let biantizhi = []
										this.$refs.baseInfo.addStatus = 'edit'
											this.$nextTick(() => {
											this.$refs.baseInfo.getOnlineAttribute(zhuAttributes)
											});
										this.saveLoadding = false
										this.dialogLoding = false
										}
							}else{
								this.$message.error(res.data.data)
							}
						})
			},
			//返回是否可以发布 true 可以发布
			isFAbu(){
				//必填已经全部填完
				let biTianAll = !this.$refs.baseInfo.formData.formDatasellerId || !this.$refs.baseInfo.allLeimuName
						|| !this.$refs.baseInfo.sku || !this.$refs.baseInfo.topAttributeList
						|| this.$refs.baseInfo.topAttributeList.some(item => {
							return (item.isRequired == 1 && (!item.fieldValue || !item.fieldValue.length))   //必填主属性不存在值
						})
						|| !this.$refs.wuliu.formData.warehouseId && !(this.$refs.wuliu.formData.vat || this.$refs.wuliu.formData.vat == 0)
						|| !this.$refs.wuliu.formData.weight && !this.$refs.wuliu.formData.weightUnit
						|| !this.$refs.wuliu.formData.width && !this.$refs.wuliu.formData.height
						|| !this.$refs.wuliu.formData.depth && !this.$refs.wuliu.formData.dimensionUnit
						|| this.$refs.onlineBianti.returnBitian() && this.$refs.baseInfo.topAttributeList.length == 0
				return !biTianAll

			},
			//保存并发布
			saveAndfabu(){
				let inputBitianObj = this.returnInputLength()
				//全部填完
				if (!inputBitianObj.bitian){
					this.$message('请填写完成必填项后，再行发布！')
				} else {
					this.saveChanpin()
				}
			},
			//返回一共有多少个输入框
			returnInputLength(){
				//input 总个数
				let inputLength = 9
				//必填总个数 包括图片
				let bitianLength = 8
				if (this.$refs.description.isShowJson){
					inputLength += 1
				}
				if (this.$refs.description.isShowChicun){
					inputLength += 1
				}
				//视频标题
				if (this.$refs.shipin.isShowBiaoti){
					inputLength += 1
				}
				//产品视频
				if (this.$refs.shipin.isShowChanpin){
					inputLength += 1
				}
				//封面视频
				if (this.$refs.shipin.isShowBiaoti){
					inputLength += 1
				}
				//变体输入框个数
				let tableLength = 6 + this.$refs.onlineBianti.headerList.length
				let bitianTableLength = (6 + this.$refs.onlineBianti.headerList.filter(item =>{
					return item.isRequired == 1
				}).length)
				//固定长度加 来源url长度
				inputLength = inputLength + tableLength + this.$refs.baseInfo.topAttributeList.length
				bitianLength = bitianLength + bitianTableLength + this.$refs.baseInfo.topAttributeList.filter(item => {
					return item.isRequired == 1
				}).length
				//以下代码计算输入值长度
				//输入个数
				let shuruInputLength = 0
				//必填输入个数
				let shuruBitianLength = 0
				//标题
				if (this.$refs.baseInfo.formData.name){
					shuruInputLength += 1
					shuruBitianLength += 1
				}
				//视频标题
				if (this.$refs.shipin.isShowBiaoti && this.$refs.shipin.formData.title){
					shuruInputLength += 1
				}
				//产品视频
				if (this.$refs.shipin.isShowChanpin && this.$refs.shipin.chanpinUrl){
					shuruInputLength += 1
				}
				//封面视频
				if (this.$refs.shipin.isShowFengmian && this.$refs.shipin.fengmianUrl){
					shuruInputLength += 1
				}
				if (this.$refs.baseInfo.topAttributeList.length > 0){
					this.$refs.baseInfo.topAttributeList.forEach(item =>{
						if (item.dictionaryId == 0 && (item.fieldValue || item.fieldValue == 'false' || item.fieldValue == '0')){
							shuruInputLength += 1
							if (item.isRequired == '1'){
								shuruBitianLength += 1
							}
						}
						if (item.dictionaryId != 0 && item.isCollection == 0 && (item.fieldValue || item.fieldValue == 0)){
							shuruInputLength += 1
							if (item.isRequired == '1'){
								shuruBitianLength += 1
							}
						}
						if (item.dictionaryId != 0  && item.isCollection == 1 && item.fieldValue && item.fieldValue.length > 0){
							//有值输入值加1
							shuruInputLength += 1
							if (item.isRequired == '1'){
								shuruBitianLength += 1
							}
						}
					})
				}
				//文字描述
				if (this.$refs.description.formData.descValue){
					shuruInputLength += 1
				}
				//json
				if (this.$refs.description.isShowJson && this.$refs.description.formData.jsonValue){
					shuruInputLength += 1
				}
				//尺寸表
				if (this.$refs.description.isShowChicun && this.$refs.description.formData.chicunValue){
					shuruInputLength += 1
				}
				//仓库
				if (this.$refs.wuliu.formData.warehouseId){
					shuruInputLength += 1
					shuruBitianLength += 1
				}
				//增值
				if (this.$refs.wuliu.formData.vat || this.$refs.wuliu.formData.vat == '0'){
					shuruInputLength += 1
					shuruBitianLength += 1
				}
				//重量
				if (this.$refs.wuliu.formData.weight){
					shuruInputLength += 1
					shuruBitianLength += 1
				}
				//长
				if (this.$refs.wuliu.formData.width){
					shuruInputLength += 1
					shuruBitianLength += 1
				}
				//宽
				if (this.$refs.wuliu.formData.height){
					shuruInputLength += 1
					shuruBitianLength += 1
				}
				//高
				if (this.$refs.wuliu.formData.depth){
					shuruInputLength += 1
					shuruBitianLength += 1
				}
				if(this.$refs.uploadPictures.imgListSelect && this.$refs.uploadPictures.imgListSelect.length > 0){
					shuruInputLength += 1
					shuruBitianLength += 1
				}
				this.$refs.onlineBianti.tableList.forEach(item => {
					//图片
					if (item.imageList && item.imageList.length > 0){
						shuruInputLength += 1
						shuruBitianLength += 1
					}
					//sku
					if (item.name){
						shuruInputLength += 1
						shuruBitianLength += 1
					}
					//sku
					if (item.offerId){
						shuruInputLength += 1
						shuruBitianLength += 1
					}
					//售价
					if (item.price || item.price == '0'){
						shuruInputLength += 1
						shuruBitianLength += 1
					}
					//原价
					if (item.oldPrice || item.oldPrice == '0'){
						shuruInputLength += 1
						shuruBitianLength += 1
					}
					//库存
					if (item.stock || item.stock == '0'){
						shuruInputLength += 1
						shuruBitianLength += 1
					}
				})
				this.$refs.onlineBianti.headerList.forEach((itemAttr,index) => {
					//input
					if (itemAttr.dictionaryId == '0'  && (itemAttr.fieldValue || itemAttr.fieldValue == '0' || itemAttr.fieldValue == 'false')){
						//必填
						if (itemAttr.isRequired == '1'){
							shuruBitianLength += 1
						}
						shuruInputLength += 1
					}
					//单选
					if (itemAttr.dictionaryId != 0 && itemAttr.isCollection == 0   && (itemAttr.fieldValue || itemAttr.fieldValue == '0' || itemAttr.fieldValue == 'false') ){
						//必填
						if (itemAttr.isRequired == '1'){
							shuruBitianLength += 1
						}
						shuruInputLength += 1
					}
					//多选
					if (itemAttr.dictionaryId != 0  && itemAttr.isCollection == 1 && itemAttr.fieldValue && itemAttr.fieldValue.length > 0){
						//必填
						if (itemAttr.isRequired == '1'){
							shuruBitianLength += 1
						}
						shuruInputLength += 1
					}
				})

				return{
					inputLength:inputLength,
					bitianLength:bitianLength,
					shuruInputLength:shuruInputLength,
					shuruBitianLength:shuruBitianLength,
					bitian:bitianLength == shuruBitianLength,
					wanchengdu:(shuruInputLength/inputLength*100).toFixed(2)
				}
			},
			//修改sku
			changeSku(val){
				this.$refs.onlineBianti.ParentSKU = val
			},
			//修改name
			changeName(val){
				this.$refs.onlineBianti.ParentName = val
			},
			//获取仓库列表
			getCangku(params){
				ajaxPost(Baseurl + 'ozonProduct/getOzonWarehouseList', params).then((res) => {
					const { code, data } = res.data
					if (code == 200) {
						this.$nextTick(() => {
							this.$refs.wuliu.cangkuList = data
						});
					}
				})
			},
			//批量编辑
			piliangEdit(){
				var that = this
				if (this.piece == 0) {
					this.$alert('请至少勾选一件产品！', '提示', {
						confirmButtonText: '确定',
					})
					return
				}
				if (this.selectTableList.some(item => {
					return item.parentSku != this.selectTableList[0].parentSku
				})){
					this.$alert('勾选产品父SKU不一致，请重新勾选！', '提示', {
						confirmButtonText: '确定',
					})
					return
				}
				this.piliangList = JSON.parse(JSON.stringify(this.selectTableList))
				this.dialogPiliangEdit = true
			},
			//同步
			tongbuItem(row){
				let that = this
				if (this.piece == 0 && !row) {
					this.$alert('请至少勾选一件产品！', '提示', {
						confirmButtonText: '确定',
					})
				} else {
					this.$confirm('此操作将同步产品, 是否继续?', '提示', {
						confirmButtonText: '确定',
						cancelButtonText: '取消',
						type: 'warning',
					})
							.then(() => {
								let params = [
									{
										ozonProductId: row.ozonProductId,
										offerId: row.offerId,
										sellerId: row.sellerId
									}
								]
								ajaxPost(
										Baseurl + 'ozonProductVariant/batchSynchronize',
										params
								).then((res) => {
									if (res.data.code == 200) {
										that.$message({
											type: 'success',
											message: '同步成功!',
										})
										that.get_table_data()
									}
								})
							})
							.catch(() => {
								this.$message({
									type: 'info',
									message: '已取消“同步”操作',
								})
							})
				}
			},
			//归档 没有row 就是批量归档
			guidangItem(row){
				let that = this
				if (this.piece == 0 && !row) {
					this.$alert('请至少勾选一件产品！', '提示', {
						confirmButtonText: '确定',
					})
				} else {
					this.$confirm('此操作将归档, 是否继续?', '提示', {
						confirmButtonText: '确定',
						cancelButtonText: '取消',
						type: 'warning',
					})
							.then(() => {
								let params
								if (!row){
									params = this.selectTableList.map(item => {
										return {
											sellerId: item.sellerId,
											ozonProductId: item.ozonProductId
										}
									})
								} else {
									params = [
										{
											sellerId: row.sellerId,
											ozonProductId: row.ozonProductId
										}
									]
								}
								ajaxPost(
										Baseurl + 'ozonProductVariant/batchArchiveVariant',
										params
								).then((res) => {
									if (res.data.code == 200) {
										that.$message({
											type: 'success',
											message: '归档成功!',
										})
										that.get_table_data()
									}
								})
							})
							.catch(() => {
								this.$message({
									type: 'info',
									message: '已取消“归档”操作',
								})
							})
				}
			},
			//取消归档
			qxGuidangItem(row){
				let that = this
				if (this.piece == 0 && !row) {
					this.$alert('请至少勾选一件产品！', '提示', {
						confirmButtonText: '确定',
					})
				} else {
				this.$confirm('此操作将取消归档, 是否继续?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning',
				})
						.then(() => {
							let params
							if (!row){
								params =	this.selectTableList.map(item => {
									return {
										sellerId: item.sellerId,
										ozonProductId: item.ozonProductId,
										offerId:item.offerId
									}
								})
							} else {
								params =[
									{
										sellerId: row.sellerId,
										ozonProductId: row.ozonProductId,
										offerId:row.offerId
									}
								]
							}
							ajaxPost(
									Baseurl + 'ozonProductVariant/batchUnarchiveVariant',
									params
							).then((res) => {
								if (res.data.code == 200) {
									that.$message({
										type: 'success',
										message: '取消归档成功!',
									})
									that.get_table_data()
								}
							})
						})
						.catch(() => {
							this.$message({
								type: 'info',
								message: '已取消“取消归档”操作',
							})
						})

				}
			},

			//同首行
			clickHeader(scope){
				let property = scope.column.property
				this.piliangList.forEach(item =>{
					item[property] = this.piliangList[0][property]
				})
			},

			//定价计算
			clickDingjia(scope){
				this.$refs.dingjia.isshowBeizhu = false
				if (this.dingjiaStatus != 'click'){
					this.dingjiaStatus = 'click'
					this.$refs.dingjia.dialogVisible = true
					this.$refs.dingjia.ruleForm.caigoudanjia = undefined
					this.$refs.dingjia.ruleForm.leimuyongjin = undefined
					this.$refs.dingjia.ruleForm.guanggao = 9
					this.$refs.dingjia.ruleForm.caigouyunfei = undefined
					this.$refs.dingjia.ruleForm.tixianshouxu = 0.7
					this.$refs.dingjia.ruleForm.cuxiaohuodong = 15
					this.$refs.dingjia.ruleForm.zhongliang = undefined
					this.$refs.dingjia.ruleForm.jinglilv = 20
					this.$refs.dingjia.ruleForm.yuguyunfei = undefined
					this.$refs.dingjia.ruleForm.shoujia = undefined
					this.$refs.dingjia.ruleForm.beizhuguocheng = undefined
				} else {
					this.$refs.dingjia.dialogVisible = true
				}

			},
			changeDingjia(val){
				this.piliangList.forEach(item =>{
					item.price = val
				})
			},
			//批量编辑保存并发布
			editSaveAndfabu(){
				let issaveStatus = true
				this.piliangList.forEach(item => {
					if (item.primaryImage == '' || item.price == '' || item.oldPrice == '' || item.stock == '' ){
						issaveStatus = false
						return
					}
				})
				if (!issaveStatus){
					this.$message({
						type: 'info',
						message: '请填写完成所有修改内容！',
					})
					return
				}
				let params = this.piliangList.map(item=>{
					return {
						id: item.id,
						oldPrice: parseFloat(item.oldPrice),
						price: parseFloat(item.price),
						stock: parseInt(item.stock),
						offerId: item.offerId,
						ozonProductId: item.ozonProductId,
						warehouseId: item.warehouseId,
						sellerId:item.sellerId
					}
				})
				ajaxPost(
						Baseurl + 'ozonProductVariant/batchUpdateAndReleaseOnlineProduct',
						params
				).then((res) => {
					if (res.data.code == 200) {
						this.dialogPiliangEdit = false
						this.$message({
							type: 'success',
							message: '批量修改成功!',
						})
						this.get_table_data()
					}
				})

			},
			//批量同步
			piliangTongbu(){
				if (this.piece == 0) {
					this.$alert('请至少勾选一件产品！', '提示', {
						confirmButtonText: '确定',
					})
					return
				}
				let that = this
				this.$confirm('此操作将同步在线产品, 是否继续?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning',
				})
						.then(() => {
							let params =this.selectTableList.map(item =>{
								return {
									ozonProductId: item.ozonProductId,
									offerId: item.offerId,
									sellerId:item.sellerId
								}
							})
							ajaxPost(
									Baseurl + 'ozonProductVariant/batchSynchronize',
									params
							).then((res) => {
								if (res.data.code == 200) {
									that.$message({
										type: 'success',
										message: '同步成功!',
									})
									that.get_table_data()
								}
							})
						})
						.catch(() => {
							this.$message({
								type: 'info',
								message: '已取消“同步”操作',
							})
						})
			}
		}
	}
</script>

<style lang="scss">
	@import "./ozon.less";
	.Release {
		width: 98%;
		// background: #F7F7F7;
		padding-bottom: 72px;
		.summary_bag {
			width: 98%;
			margin: auto;
			.summary_complete_bag {
				overflow: hidden;
				.summary_complete {
					overflow: hidden;
					padding: 10px 0;
					border-bottom: 1px #eee solid;
					div {
						padding: 0 10px;
						height: 30px;
						border: #2c8dff 1px solid;
						line-height: 30px;
						text-align: center;
						color: #2c8dff;
						float: left;
						border-radius: 4px;
						cursor: pointer;
					}
					.active {
						background: #2c8dff;
						color: #fff;
					}
				}
			}
			.summary_pagenum {
				width: 100%;
				margin-bottom: 10px;
				overflow: hidden;
				background: #f5f5f5;
				.summary_query {
					width: 20%;
					float: left;
					padding: 0 10px;
					line-height: 32px;
					letter-spacing: 1px;
					color: #585858;
					span {
						color: #2c8dff;
					}
				}
				.block {
					float: right;
				}
			}
			.summary_content {
				width: 100%;
				border: 1px solid #eee;
				overflow: hidden;
				.summary_batch {
					width: 100%;
					overflow: hidden;
					border-bottom: 1px solid #eee;
					span {
						display: block;
						float: left;
						line-height: 20px;
						margin: 10px 0px;
						padding: 0 20px;
						color: #2c8dff;
						overflow: hidden;
						border-left: 1px #2c8dff solid;
					}
					span:nth-child(1) {
						color: #000;
						border-left: 0px;
					}
				}
			}
			.summary_list {
				.scope_img {
					width: 55px;
					height: 55px;
					margin: 0 auto;
					img {
						width: 100%;
						height: 100%;
					}
				}
				.oper {
					color: #2c8dff;
					margin-right: 10px;
					cursor: pointer;
				}
			}
		}
	}
	.item_sku{
		width: 100%;
	}
	.custom-formScreen {
		::v-deep {
			.el-form-item__content {
				width: calc(100% - 125px);
			}
		}
	}
	.zhankai_shouqi{
		width: 30px;
		height: 30px;
		border-radius: 5px;
		background: rgb(168,168,168);
		display: flex;
		align-items: center;
		justify-content: center;
		margin-left: 15px;
		cursor: pointer;
	}
	.item_yuan{
		width: 15px;
		height: 15px;
		border-radius: 50%;
		margin-left: 15px;
		cursor: pointer;
	}
	.red_yuan{
		background: red;
	}
	.green_yuan{
		background: green;
	}

	.scope_img {
		width: 55px;
		height: 55px;
		margin: 0 auto;
		img {
			width: 100%;
			height: 100%;
		}
	}
</style>
